/**
* Version 0.100
* 
* Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
* Copyright 2016 - 2025.
* 
* !Changelog

* 	17-10-2018
* 	- [BORN] This class is born. Hooray!
* 
* !Usage
* 
*   - 
* 	
* !Wishlist
* 
* 	// none
* 	
*/

var specific_menubutton = {};

(function () {

	// DOCUMENT READY  *****************************************************************
	// DOCUMENT READY *****************************************************************
	// DOCUMENT READY ******************************************************************
	// DOCUMENT READY ******************************************************************

	this.onready = function (
	) {

		$(document).on('click', '.js-menubutton-toggle', function () {
			$(this).toggleClass('active');

			/**
			 * If menu is closed, scroll js-menu-content-toggle and set to top
			 */
			if (!$('.js-menubutton-toggle').hasClass('active')) {
				$('.js-menu-content-toggle').scrollTop(0);
			}

			$('.js-menu-background-toggle').toggleClass('active');
			$('.js-menu-content-toggle').toggleClass('active');
		});

		/**
		 * Click study menu mobile alert
		 */
		$(document).on('click', '.js-study-menu-mobile', function () {
			popup.open(1, 1, 'study-menu');
		});

	};

	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************

	this.close = function () {
		$('.js-menubutton-toggle').removeClass('active');
		$('.js-menu-background-toggle').removeClass('active');
		$('.js-menu-content-toggle').removeClass('active');
	};

}).apply(specific_menubutton);